import { Stack } from "@mui/material";
import { FC } from "react";
import { InfrastructureArchitectureRecommendationDrawerBodyImprovement } from "./InfrastructureArchitectureRecommendationPanelImprovement";
import { InfrastructureArchitectureRecommendationPanelLoading } from "./InfrastructureArchitectureRecommendationPanelLoading";
import { InfrastructureArchitectureRecommendationPanelNoData } from "./InfrastructureArchitectureRecommendationPanelNoData";
import { InfrastructureArchitectureRecommendationDrawerDoc } from "./docs/InfrastructureArchitectureRecommendationDrawerDoc";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureRecommendationLoadingSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationLoadingSelector";
import { infrastructureArchitectureDiagramEmptyDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramEmptyDataSelector";
import { infrastructureArchitectureRecommendationNoDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationNoDataSelector";

export const InfrastructureArchitectureRecommendationPanelBody: FC = () => {
  const recommendationLoading = useAppSelector(
    infrastructureArchitectureRecommendationLoadingSelector,
  );
  const noData = useAppSelector(
    infrastructureArchitectureRecommendationNoDataSelector,
  );
  const diagramDataEmpty = useAppSelector(
    infrastructureArchitectureDiagramEmptyDataSelector,
  );

  if (recommendationLoading) {
    return <InfrastructureArchitectureRecommendationPanelLoading />;
  }

  if (noData || diagramDataEmpty) {
    return <InfrastructureArchitectureRecommendationPanelNoData />;
  }

  return (
    <Stack spacing={1} px={2} pb={2} flex={1} sx={{ overflowY: "auto" }}>
      <InfrastructureArchitectureRecommendationDrawerBodyImprovement />
      <InfrastructureArchitectureRecommendationDrawerDoc />
    </Stack>
  );
};
